import styled, { keyframes } from 'styled-components';

const showOtherInput = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

export const Container = styled.div`
  width: 100%;
  font-family: 'Amorim Sans Book';

  .overflow-scroll {
    padding-right: 15px;
    padding-left: 15px;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    max-height: calc(100vh - 274px);
    scroll-behavior: smooth;

    @media (min-width: 768px) {
      padding-right: 0;
      padding-left: 0;
      max-height: initial;
    }
  }

  .title {
    font-family: 'Amorim Sans Serif';
    letter-spacing: 2px;
    margin-top: 26px;
    @media (min-width: 768px) {
      margin-top: 48px;
    }
  }

  .centered {
    @media (min-width: 768px) {
      max-width: 580px;
      margin: 0 auto;
    }
  }

  .name {
    margin-top: 22px;
    @media (min-width: 768px) {
      margin-top: 10px;
    }
  }

  .email {
    margin-top: 21px;
    @media (min-width: 768px) {
      margin-top: 25px;
    }
  }

  .phone {
    margin-top: 21px;
    @media (min-width: 768px) {
      margin-top: 0;
    }
  }

  .country {
    margin-top: 20px;
    @media (min-width: 768px) {
      margin-top: 25px;
    }
  }

  .zipcode {
    margin-top: 10px;
    @media (min-width: 768px) {
      margin-top: 0;
    }
  }

  .unity-business {
    margin-top: 20px;
    @media (min-width: 768px) {
      margin-top: 16px;
    }
  }

  .subject {
    margin-top: 16px;

    > div {
      margin-top: 20px;

      @media (min-width: 768px) {
        margin-top: 16px;
      }
    }
    @media (min-width: 768px) {
      margin-top: 24px;
    }
  }

  .message {
    margin-top: 20px;
    @media (min-width: 768px) {
      margin-top: 22px;
    }
  }
`

export const ValidationError = styled.span`
  position: absolute;
  display: flex;
  align-items: center;
  top: 30px;
  left: 15px;
  font-size: 14px;
  letter-spacing: 1.2px;
  color: #c22c31;
  animation: ${showOtherInput} .3s ease-in forwards;

  svg {
    fill: #c22c31;
    margin-bottom: 2px;
    margin-right: 6px;
  }
`

export const Title = styled.h1`
  color: #2D5A64;
  letter-spacing: 2px;
  font-size: 7vw;
  padding: 0 15px;

  @media (min-width: 768px) {
    font-size: 30px;
    letter-spacing: 3px;
    font-size: 35px;
    padding: 0;
  }
`

export const InputText = styled.input`
  width: 100%;
  height: 32px;
  border: none;
  outline: none;
  border-top: solid 1px #AFAEAE;
  color: #AFAEAE;
  letter-spacing: 1.28px;
  transition: all .3s linear;
  padding: 0 4px;

  &.b-bottom {
    border-top: none;
    border-bottom: solid 1px #AFAEAE;
    font-size: 14px;
  }
  
  &:focus {
    border-top: solid 1px #8AB1B5;
    color: #8AB1B5;

    &.b-bottom {
      border-top: none;
      border-bottom: solid 1px #8AB1B5;
    }

    &::placeholder {
      color: #8AB1B5;
    }
  }

  &.filled {
    color: #1A1919;
    border-top: solid 1px#1A1919;

    &.b-bottom {
      border-top: none;
      border-bottom: solid 1px #1A1919;
    }

    &:focus {
      border-top: solid 1px #8AB1B5;
      color: #8AB1B5;

      &.b-bottom {
        border-top: none;
        border-bottom: solid 1px #8AB1B5;
      }
    }
  }

  &::placeholder {
    color: #AFAEAE;
    transition: all .3s linear;
  }
`

export const TextArea = styled.textarea`
  width: 100%;
  padding: 4px 4px;
  height: 100%;
  min-height: 170px;
  max-height: 170px;
  border: none;
  outline: none;
  border-top: solid 1px #AFAEAE;
  color: #AFAEAE;
  letter-spacing: 1.28px;
  transition: all .3s linear;

  @media (min-width: 768px) {
    min-height: 100px;
    max-height: 100px;
  }
  
  &:focus {
    border-top: solid 1px #1A1919;
    color: #1A1919;
    &::placeholder {
      color: #1A1919;
    }
  }

  &.filled {
      color: #1A1919;
      border-top: solid 1px#1A1919;
  }

  &::placeholder {
    color: #AFAEAE;
    transition: all .3s linear;
  }
`

export const Select = styled.select`
  display: block;
  height: 40px;
  padding: 0 0 6px 4px;
  border: none;
  outline: none;
  border-top: solid 1px #AFAEAE;
  letter-spacing: 1.28px;
  font-size: 16px;
  color: #AFAEAE;
  line-height: 1.3;
  width: 100%;
  max-width: 100%; 
  box-sizing: border-box;
  margin: 0;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3Csvg stroke='currentColor' fill='currentColor' stroke-width='0' viewBox='0 0 320 512' color='%23bfbfbf' height='13' width='13' xmlns='http://www.w3.org/2000/svg' style='color: rgb(191, 191, 191);'%3E%3Cpath d='M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z'%3E%3C/path%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right .3em top 9px;
  background-size: .80em auto;
  transition: all .3s linear;

  &.filled {
    border-top: solid 1px #1A1919;
    color:#1A1919;
    background-image: url("data:image/svg+xml,%3Csvg stroke='currentColor' fill='currentColor' stroke-width='0' viewBox='0 0 320 512' color='%231a1919' height='13' width='13' xmlns='http://www.w3.org/2000/svg' style='color: rgb(26, 25, 25);'%3E%3Cpath d='M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z'%3E%3C/path%3E%3C/svg%3E");
  }

  option {
    background-color: #fff;
  }
`

export const TitleBordered = styled.p`
  width: 100%;
  height: 20px;
  border-top: solid 1px #AFAEAE;
  color: #AFAEAE;
  letter-spacing: 1.28px;
  transition: all .3s linear;
  padding: 4px 4px 0 4px;

  &.filled {
    border-top: solid 1px #1A1919;
    color:#1A1919;
  }
`

export const RadioContainer = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 50% 50%;
  grid-auto-rows: 28px;
  grid-column-gap: 10px;
  margin-top: 0;

  .other {
    position: absolute;
    height: 18px;
    width: calc(100% - 70px);
    bottom: 16px;
    right: 0;
    animation: ${showOtherInput} .3s ease-in forwards;

    @media (min-width: 768px) {
      width: calc(42% + 42%);
      height: 32px;
      bottom: 2px;
    }
  }

  @media (min-width: 768px) {
    margin-top: 20px;
    grid-template-columns: 33% 33% 34%;
    grid-auto-rows: 28px;
  }
`

export const InputRadio = styled.input`
  border: none;
  padding-left: 4px;
  margin-right: 4px;
  height: 10px;
  outline: none;
  font-size: 14px;
  border-top: solid 1px #AFAEAE;
  color: #AFAEAE;
  letter-spacing: 1.28px;
  transition: all .3s linear;
`

export const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: 3px;
  margin-left: 0;
  cursor: pointer;
  font-size: 12px;
  letter-spacing: 1.2px;
  color: #AFAEAE;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  @media (min-width: 768px) {
    margin-left: 4px;
  }

  &.filled {
    color: #1A1919;
  }

  input {
    margin-top: 2px;
  }
`

export const InputCheckBox = styled.input`
  border: none;
  padding-left: 4px;
  margin-right: 4px;
  height: 10px;
  outline: none;
  border-top: solid 1px #AFAEAE;
  color: #AFAEAE;
  letter-spacing: 1.28px;
  transition: all .3s linear;
`
export const CheckLabel = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: 3px;
  margin-left: 4px;
  cursor: pointer;
  font-size: 14px;
  color: #AFAEAE;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  transition: all .3s linear;

  &.filled {
    color: #1A1919;
  }
`

export const FormButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 64px;
  background: #FFF;
  border: 1px solid #1D3739;
  text-transform: uppercase;
  letter-spacing: 1.6px;
  color: #1D3739;
  font-size: 24px;
  transition: all .1s linear;
  outline: none;

  &:focus {
    outline: none;
  }

  &:disabled {
    opacity: .5;
    cursor: not-allowed;
  }

  &:hover {
    &:not(:disabled) {
      cursor: pointer;
      background: #1D3739;
      color: #FFF;
    }
  }
`
